import { render, staticRenderFns } from "./TipoObrasCadastro.vue?vue&type=template&id=bafd110c&scoped=true&"
import script from "./TipoObrasCadastro.vue?vue&type=script&lang=js&"
export * from "./TipoObrasCadastro.vue?vue&type=script&lang=js&"
import style0 from "./TipoObrasCadastro.vue?vue&type=style&index=0&id=bafd110c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafd110c",
  null
  
)

export default component.exports